// ABOUTME: The 3A entrance's fades for the stack's tiers: a tier steps back to the dimmed opacity, and its copy to a lower one.
// ABOUTME: Shared by the stack and the sculpted cloud so both read the same timings.

import { keyframes } from '@emotion/react';

export const DIMMED_OPACITY = 0.3;
export const TOWER_FADE_DELAY_SEC = 2.8;
export const COPY_FADE_DELAY_SEC = 3.1;
// The tier fades to DIMMED_OPACITY and its copy to a lower one; the copy sits inside the tier, so the two multiply to 0.12.
export const COPY_OPACITY = 0.4;

const fadeTower = keyframes`
  to { opacity: ${DIMMED_OPACITY}; }
`;
const fadeCopy = keyframes`
  to { opacity: ${COPY_OPACITY}; }
`;

// The fade of a tier's silhouette; `copy` adds the fade of the words it holds.
export function settleSx(reducedMotion: boolean, copy: boolean) {
  if (reducedMotion) return { opacity: DIMMED_OPACITY, ...(copy ? { '& .MuiTypography-root': { opacity: COPY_OPACITY } } : {}) };
  return {
    animationName: `${fadeTower}`, animationTimingFunction: 'ease', animationFillMode: 'forwards',
    ...(copy ? {
      '& .MuiTypography-root': {
        animationName: `${fadeCopy}`, animationDuration: '0.9s', animationDelay: `${COPY_FADE_DELAY_SEC}s`,
        animationTimingFunction: 'ease', animationFillMode: 'forwards',
      },
    } : {}),
  };
}

export const settleStyle = (reducedMotion: boolean) => (
  reducedMotion ? undefined : { animationDuration: '1s', animationDelay: `${TOWER_FADE_DELAY_SEC}s` }
);
